import { useEffect, useRef } from "react";

const PALETTE = (() => {
    const p = [];
    for (let i = 0; i < 36; i++) {
        const t = i / 35;
        let r;
        let g;
        let b;
        if (t < 0.33) {
            r = (t / 0.33) * 180;
            g = 0;
            b = 0;
        } else if (t < 0.66) {
            r = 180 + ((t - 0.33) / 0.33) * 75;
            g = ((t - 0.33) / 0.33) * 140;
            b = 0;
        } else {
            r = 255;
            g = 140 + ((t - 0.66) / 0.34) * 115;
            b = ((t - 0.66) / 0.34) * 120;
        }
        p.push(`rgb(${r | 0},${g | 0},${b | 0})`);
    }
    return p;
})();

export default function FireLogo() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const W = 70;
        const H = 42;
        const PX = 4;
        const heat = new Float32Array(W * H);
        let raf;
        let tick = 0;
        const step = () => {
            tick += 1;
            if (tick % 2 === 0) {
                for (let x = 0; x < W; x++) heat[(H - 1) * W + x] = 32 + Math.random() * 4;
                for (let y = 0; y < H - 1; y++) {
                    for (let x = 0; x < W; x++) {
                        const srcX = Math.min(W - 1, Math.max(0, x + ((Math.random() * 3) | 0) - 1));
                        heat[y * W + x] = Math.max(0, heat[(y + 1) * W + srcX] - Math.random() * 2.0);
                    }
                }
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let y = 0; y < H; y++) {
                for (let x = 0; x < W; x++) {
                    const h = heat[y * W + x];
                    if (h > 3) {
                        ctx.fillStyle = PALETTE[Math.min(35, h | 0)];
                        ctx.fillRect(x * PX, y * PX, PX, PX);
                    }
                }
            }
            raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, []);

    return (
        <div className="relative" data-testid="fire-logo">
            <img
                src="/assets/asset2.png"
                alt="Grill Enforcers logo"
                className="w-64 rounded-sm sm:w-72"
            />
            <canvas
                ref={canvasRef}
                width={280}
                height={168}
                className="pixelated pointer-events-none absolute inset-0 h-full w-full"
                style={{ mixBlendMode: "screen" }}
            />
        </div>
    );
}
